export const CONFLUENCE_EDITION = {
	//copied from change-edition. Was not allowed to import it into preloadContentHeader + to prevent bundle size increase.
	FREE: 'FREE',
	PREMIUM: 'PREMIUM',
	STANDARD: 'STANDARD',
};

export const SHUT_DOWN_MANAGE_WATCHERS_FF =
	'confluence.frontend.shut-down-manage-watchers-for-unpaid';

export const ONE_CLICK_WATCH_FF = 'confluence.frontend.change_watch_experience';
